import { render, staticRenderFns } from "./bank-verified.vue?vue&type=template&id=478abd6c&"
import script from "./bank-verified.vue?vue&type=script&lang=js&"
export * from "./bank-verified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports